module.exports = __webpack_public_path__ + "static/media/team-member-04.097927a4.jpg";